import { render, staticRenderFns } from "./CardAnaliseSocioambientalOperacao.vue?vue&type=template&id=563ff40e&lang=pug"
import script from "./CardAnaliseSocioambientalOperacao.vue?vue&type=script&lang=js"
export * from "./CardAnaliseSocioambientalOperacao.vue?vue&type=script&lang=js"
import style0 from "./CardAnaliseSocioambientalOperacao.vue?vue&type=style&index=0&id=563ff40e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports